import * as React from 'react';
import clickable from '../logic/clickable';
import * as UiList from './UiList';

export type ItemProps = UiList.ItemProps;

export const Item: React.ComponentType<UiList.ItemProps> = clickable(
  UiList.Item
);
export const Icon = UiList.Icon;
export const Label = UiList.Label;
